import React, { useEffect, useState } from "react";
import "./ShopCreate.css";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import { Tab, Tabs } from "react-bootstrap";
function ShopCreate() {
  const [key, setKey] = useState("home");

  const [image, setImage] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const [shopName, setShopName] = useState("");
  const [blockchain, setBlockchain] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [description, setDescription] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [walletAddress, setWalletKey] = useState("");

  // const handleSubmit = async () => {
  //   console.log(properties);
  //   if (imageURL == null || imageURL == "") {
  //     toast("please select image");
  //   } else if (name == null || name == "") {
  //     toast("please put name");
  //   } else if (description == null || description == "") {
  //     toast("please put description");
  //   } else {
  //     await addDoc(collection(firestoredb, "metamuze_CreateNFT"), {
  //       walletAddress: walletAddress,
  //       itemName: name,
  //       itemImg: photoURL,
  //       externalLinks: url,
  //       description: description,
  //       itemSupply: supply,
  //       collections: selectedcollections,
  //       unlockable: unlockable,
  //       explicit: explicit,
  //       blockchain: blockchain,
  //     });
  //   }
  // };

  const walletListner = async () => {
    // console.log(window.solana);

    // @ts-ignore
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        // console.log("wallet account ", response.publicKey.toString());
        // console.log(response.publicKey.toString());

        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };

  useEffect(() => {
    walletListner();
  }, []);

  return (
    <div>
      <section className="physical-item shop create-own-bg">
        <div className="hero-section">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 right">
                <h1>upload banner </h1>
                <button className="upload-photo">upload cover photo</button>
              </div>
            </div>
          </div>
        </div>

        <div className="physical-item-content">
          <div className="container">
            <div className="row ">
              <div className="col-1"></div>

              <div className="col-10">
                <h6>Shop Profle Image</h6>
                <p className="filetype">
                  File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                  OGG, GLB, GLTF . Max size : 100MB
                </p>

                <div className="row mt-5">
                  <div className="col-md-4">
                    <img
                      src="../../assets/images/createyourown/chooseimg.png"
                      alt=""
                      className="img-fluid img-picker"
                    />
                  </div>

                  <div className="col-md-8">
                    {/* ------------ */}
                    <div className=" rigt-side-wrap d-flex justify-content-between flex-column h-100">
                      <div>
                        <h3 className="craete-tit">Shop Name :</h3>
                        <input
                          className="create-input-txt mt-2"
                          placeholder="Mojo T - Shirts"
                          type="text"
                        />
                      </div>
                      <div>
                        <h3 className="craete-tit">Wallet Address :</h3>
                        <input
                          className="create-input-txt mt-2"
                          placeholder="o90jkjhhd79495ojfjgnd"
                          type="text"
                        />
                      </div>
                    </div>
                    {/* ------------ */}
                  </div>

                  <div className="col-12 mt-4">
                    <div className="text-area-section">
                      <h3 className="craete-tit mt-3">Description</h3>
                      <p className="create-txt mt-3">
                        The description will be included on the item's detail
                        page underneath its image.{" "}
                        <span className="xx">Markdown </span>
                        syntax is supported.
                      </p>
                      <textarea
                        rows="4"
                        className="textareadescription mt-3"
                        placeholder="Provide a detailed description of your item."
                      />
                    </div>
                  </div>

                  <div className="row mt-5 product-pric">
                    <h3 className="craete-tit">Price</h3>
                    <div className="col-md-4 mt-2">
                      <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                      >
                        <Tab
                          eventKey="home"
                          title="Standard"
                          className="tab-tit"
                        >
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                              className="d-flex justify-content-between align-items-center "
                            >
                              <div>
                                <img
                                  src="\assets\images\icons\solona.png"
                                  alt=""
                                  className="me-2"
                                />
                                SOL
                              </div>
                              <Icon
                                icon="ep:arrow-down-bold"
                                color="#000000"
                                width="16"
                                height="16"
                              />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\dust.png"
                                    alt=""
                                    className="me-2"
                                  />
                                  DUST
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2" className="">
                                <div>
                                  <img
                                    src="\assets\images\icons\usdc.png"
                                    alt=""
                                    className="me-2"
                                  />
                                  USDC
                                </div>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </Tab>
                        <Tab
                          eventKey="profile"
                          title="Premium"
                          className="tab-tit"
                        >
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="success"
                              id="dropdown-basic"
                              className="d-flex justify-content-between align-items-center "
                            >
                              <div className="spltoken">SPL TOKEN</div>
                            </Dropdown.Toggle>
                          </Dropdown>
                        </Tab>
                      </Tabs>
                    </div>
                    <div className="row">
                      <div className="col-sm-12  c-btn">
                        <button className="createitembtn me-3 mt-5">
                          Create
                        </button>
                      </div>
                      <hr className="divid" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-1"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ShopCreate;
